import { ErrorHandler, Injectable } from '@angular/core';
import { logErrorWithPrefix } from './error-util';

@Injectable()
export class ErrorHandlerService implements ErrorHandler {
  handleError(error: object): void {
    logErrorWithPrefix('An error occurred:', error);
  }
}
